import { render, staticRenderFns } from "./MAM005-visualizarProveedores.vue?vue&type=template&id=073eb1d4&scoped=true&"
import script from "./MAM005-visualizarProveedores.vue?vue&type=script&lang=js&"
export * from "./MAM005-visualizarProveedores.vue?vue&type=script&lang=js&"
import style0 from "./MAM005-visualizarProveedores.vue?vue&type=style&index=0&id=073eb1d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073eb1d4",
  null
  
)

export default component.exports